import Menu from './Compartido/Menu.jsx';
import TextoContacto from './Contacto/TextoContacto.jsx';
import Footer from './Compartido/Footer.jsx';
import Scripts from './Compartido/Scripts.jsx';

const Contacto = (props) => {
    return (
        <main>
            <Menu
                lang={props.lang}
                meta_titulo={props.meta_titulo}
                meta_descripcion={props.meta_descripcion}
                meta_keywords={props.meta_keywords}
                ruta={props.ruta}
                config={props.websgrupo}
                pagina="4_Contacto"
                destinos={props.destinos}
                tiposcasas={props.tiposcasas}
            />
            <TextoContacto
                lang={props.lang}
                datos={props.websgrupo}
            />
            <Footer
                lang={props.lang}
                datos={props.websgrupo}
            />
            <Scripts />
        </main>
    )
}
export default Contacto;

